const injectSearchspring = () => {
  const footer = document.querySelector('.relative.p-4.bg-grey-100');

  if (!footer) return;

  // prevent duplicates
  if (footer.previousElementSibling?.classList.contains('searchspring-recs')) return;

  const recs = document.createElement('div');
  recs.className = 'searchspring-recs mb-4';

  recs.innerHTML = `
    <script type="searchspring/personalized-recommendations" profile="side-cart"></script>
  `;

  footer.parentNode.insertBefore(recs, footer);
};

// observe cart updates
new MutationObserver(injectSearchspring).observe(document.body, {
  childList: true,
  subtree: true
});

// initial run
injectSearchspring();